import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Grid } from '@mui/material';

export const OfferFinancialServicesItemSummary = ({ t, item, idx, currencyCode }) => (
  <Grid item xs={12} sm={6} display='flex' alignItems='center'>
    <strong id={'offerFinancialServicesCard_summary_item_' + idx + '_name'}>{item.name}: </strong>
    {item.errorMessage ? (
      <span id={'offerFinancialServicesCard_summary_item_' + idx + '_value'}>
        <PriorityHighIcon fontSize='small' color='error' />
      </span>
    ) : (
      <span id={'offerFinancialServicesCard_summary_item_' + idx + '_value'}>
        {t('DECIMAL2', { number: item.serviceMonthlyAmount })} {currencyCode} / {t('OfferEdit.FinancialServices.Month')}
      </span>
    )}
  </Grid>
);

OfferFinancialServicesItemSummary.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object,
  idx: PropTypes.number.isRequired,
  currencyCode: PropTypes.string
};

export default withTranslation()(memo(OfferFinancialServicesItemSummary));
